// 图表库全局配置
export const configureCharts = () => {
  // 禁用 @ant-design/charts 的 Shadow DOM
  if (typeof window !== 'undefined') {
    // G2Plot配置
    window.g2plot_container_custom_render_mode = true;
    window.g2plot_container_renderer = 'canvas';
    
    // G2配置
    window.G2 = window.G2 || {};
    window.G2.Global = window.G2.Global || {};
    window.G2.Global.renderer = 'canvas';
    window.G2.Global.disableShadow = true;
    
    // 额外配置
    window.g2_renderer = 'canvas';
    window.g2_custom_render_mode = true;
    window.bizcharts_renderer = 'canvas';
  }
};

// 默认导出图表配置对象
export default {
  // 图表通用配置
  commonConfig: {
    renderer: 'canvas',
    animation: false,
    theme: {
      styleSheet: {
        brandColor: '#1890ff',
        paletteQualitative10: [
          '#1890ff',
          '#52c41a',
          '#faad14',
          '#f5222d',
          '#722ed1',
          '#13c2c2',
          '#eb2f96',
          '#fa8c16',
          '#a0d911',
          '#fadb14'
        ]
      }
    }
  }
}; 